import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9bbf1ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]



interface Props {
  show: boolean;
  checked: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
    show: { type: Boolean },
    checked: { type: Boolean }
  },
  setup(__props: any) {



const image = (checked: boolean) => checked ? require('@/assets/img/checked.svg') : require('@/assets/img/unchecked.svg');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: image(__props.checked),
    alt: "",
    class: _normalizeClass({show:__props.show})
  }, null, 10, _hoisted_1))
}
}

})